<template>
  <div class="seomain">
    <div class="info-main">
      <div class="info-left">
        <ul>
          <li><span>盘点仓库：</span>{{ stinfo.warehouse_name }}</li>
          <li><span>盘点时间：</span>{{ stinfo.planstarttime }}</li>
          <li><span>盘点状态：</span>{{ stinfo.status }}</li>
          <li><span>盘点负责人：</span>{{ stinfo.admin_name }}</li>
        </ul>
      </div>
      <div class="info-scan">
        <!-- <van-icon name="photograph" /> -->
      </div>
    </div>
    <div class="info-detail-list">
      <div
        v-for="(v, k) in stlist"
        :key="k"
        :class="v.abnormal == '1' ? 'status-01' : v.abnormal == '-1' ? 'status-02' : 'status-00'"
        @click="show_detail_box(v.inventoryplan_products_id, v.quantity)"
      >
        <dl>
          <dt>{{ v.inventory_position_name }}</dt>
          <dd class="num">
            <span v-if="v.abnormal != '0'">{{ v.quantity }}</span>
          </dd>
          <!-- 右箭头 -->
          <dd class="arrow"><i class="iconfont icon-icon1"></i></dd>
        </dl>
      </div>
    </div>
    <van-dialog v-model="show" show-cancel-button @confirm="edit_st2()">
      <div class="mix-detail-box">
        <h2>{{ oneinfo.products_sku }}</h2>
        <p>库存编码：{{ oneinfo.inventory_code }}</p>
        <p>产品名称：{{ oneinfo.products_name }}</p>
        <p>仓位：{{ oneinfo.inventory_position }}</p>
        <el-input v-model="dialog_num" placeholder="请输入数量"></el-input>
      </div>
    </van-dialog>

    <div class="pa-btn" @click="changeStatusBtnHandle" v-if="flag != 'false'">
      盘点完成
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      dialog_num: "",
      show: !1,
      stlist: [],
      stinfo: {},
      oneinfo: {},
      paramsid: 0,
      activeid: 0,
    };
  },
  watch: {},
  computed: {
    flag() {
      return this.$route.params.flag;
    },
  },
  methods: {
    edit_st2: function() {
      if (this.flag == "false") return;
      let t = this;
      if (this.$isEmpty(this.dialog_num)) {
        return this.$toastor("请先填写内容");
      } else {
        t.edit_st();
      }
    },
    edit_st: function() {
      console.log(this.activeid);
      var ss = { id: this.activeid, stnum: this.dialog_num };
      console.log(ss);
      this.$post(this.$api.stGetPandianEdit, ss).then((res) => {
        if (res.code == 200) {
          this.$toast.success("修改成功");
          this.get_st_info();
        } else {
          this.$toastor(res.msg);
        }
      });
    },
    show_detail_box: function(id, value) {
      if (this.flag == "false") return;
      this.$post(this.$api.stGetPandianView, { id }).then((res) => {
        this.oneinfo = res.data;
        this.activeid = res.data.inventory_products_id;
        console.log(this.activeid);
        this.dialog_num = value;
        this.show = !0;
      });
    },
    get_st_info: function() {
      let paramsid = this.$route.params.id;
      this.$post(this.$api.stGetPandianInfo, { id: paramsid }).then((res) => {
        this.stlist = res.data.list;
        this.stinfo = res.data.info;
      });
    },

    // 点击盘点完成的回调
    async changeStatusBtnHandle() {
      let flag = await this.$dialog.confirm({
        title: "是否完成盘点",
        message: "提交后将变为已完成状态，\n请确认数据准确。",
      });
      if (flag == "confirm") {
        let paramsid = this.$route.params.id;
        let result = await this.$post(this.$api.stSetPandianEnd, {
          id: paramsid,
        });
        if (result.code == 200) {
          this.$toast.success("提交成功");
          this.$router.push("/inventory/list");
        }
      }
    },
  },
  created() {
    this.get_st_info();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "盘点" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.info-main {
  display: flex;
  padding: 10px 20px;
  background: #fff;
  margin-bottom: 15px;
}
.info-main .info-left {
  flex: 1;
  line-height: 2.2;
}

.info-scan {
  margin-top: 2.5em;
  margin-right: 1.5em;
}
.info-scan .van-icon {
  color: #0ba;
  font-size: 50px;
}

.info-detail-list {
  padding: 10px 20px;
  background: #fff;
}
.info-detail-list dl {
  display: flex;
  border-bottom: 1px solid #e5e5e5;
  line-height: 30px;
  padding-top: 10px;
  padding-bottom: 5px;
}
.info-detail-list dt {
  flex: 1;
}
.info-detail-list .num {
  padding: 0 10px;
}
.info-detail-list .iconfont {
  color: #ddd;
  font-weight: bolder;
  font-size: 24px;
}

.status-00 {
  font-weight: normal;
}
.status-01 {
  color: #43cf7c;
}
.status-02 {
  color: #ff5733;
}

.seomain {
  box-sizing: border-box;
  position: relative;
  padding-bottom: 55px;
}
.seomain .pa-btn {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 55px;
  line-height: 55px;
  text-align: center;
  color: #fff;
  background-color: #677588;
}
</style>
